import React, { useRef } from "react";
import { Button, Card, Divider, Modal } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import RoForm from "./RoForm";
import RoDetailList from "./RoDetailList";
import { useModel, useModelDispatchers } from "../../../models";
import PaymentDrawer from "./PaymentDrawer";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import UpOutlined from "@ant-design/icons/lib/icons/UpOutlined";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import RoPrint from "./RoPrint";
import { debounce } from "lodash";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const history = useHistory();
    const formRef = useRef();
    const printRef = useRef();
    const { closeNav } = useModelDispatchers("nav");
    const [{
        selectedDocument,
        formExpand
    }, {
        disable,
        whConfirm,
        setPaymentDrawerVisible,
        toggleExpand,
        loadRo
    }] = useModel("purchaseRo");
    const [{ preview }, { setPreview }] = useModel("global")
    const getForm = () => {
        return formRef.current.form();
    };
    const onPrint = () => {
        setPreview({
            visible: true,
            __html: printRef.current.dom().innerHTML
        })
    }
    const onDisable = () => {
        Modal.confirm({
            title: "确认作废此单据？",
            centered: true,
            closable: true,
            onOk: () => {
                disable({ showMsg: true, data: selectedDocument.id })
            },
            onCancel: () => { }
        });
    }
    const onWhConfirm = async () => {
        let ret = await formRef.current.update()
        if (ret) {
            const { id: data } = selectedDocument;
            await whConfirm({ showMsg: true, data })
            await onRefresh()
        }
        // whConfirm({showMsg: true, data: selectedDocument.id})
    }
    const onSettle = () => {
        setPaymentDrawerVisible(true);
    }
    const onSave = () => {
        formRef.current.update();
    }
    const onBack = () => {
        closeNav();
        goPage(history, "2-4");
    }
    const onRefresh = async () => {
        const { id } = selectedDocument;
        await loadRo({ showMsg: true, data: id })
    }
    const onToggleExpand = () => {
        toggleExpand();
    }


    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">采购退货单明细</span>
                    <span
                        className="margin-left-16">
                        {selectedDocument.returnCode} [{selectedDocument.orderStatusName}]
                    </span>
                    <span
                        className="margin-left-16"
                        onClick={onToggleExpand}
                        style={{ cursor: "pointer" }}
                    >
                        {formExpand ? <UpOutlined /> : <DownOutlined />}
                    </span>
                </h3>
                <div style={{ width: "600px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.PR_ED_CANCEL}>
                        <Button
                            onClick={onDisable}
                            disabled={selectedDocument.orderStatus !== "027001" //开单
                            }
                        >
                            作废
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.PR_ED_PRINT}>
                        <Button
                            className="margin-left-8"
                            onClick={onPrint}
                        >
                            打印
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.PR_ED_BILL}>
                        <Button
                            className="margin-left-8"
                            onClick={onSettle}
                            disabled={
                                !(selectedDocument.orderStatus === "027002"//出库
                                    || selectedDocument.orderStatus === "027003")
                            }
                        >
                            结算
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.PR_ED_CONFIRM}>
                        <Button
                            className="margin-left-8"
                            onClick={debounce(onWhConfirm, 600)}
                            disabled={
                                selectedDocument.orderStatus !== "027001"//开单
                            }
                        >
                            库房确认
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.PR_ED_SAVE}>
                        <Button
                            className="margin-left-8"
                            type="primary"
                            onClick={debounce(onSave, 600)}
                            disabled={
                                selectedDocument.orderStatus === "027004"//禁用
                                || selectedDocument.orderStatus === "027003"//结算
                                || selectedDocument.orderStatus === "027002"

                            }
                        >
                            保存
                    </Button>
                    </YhAuth>
                    <Button
                        className="margin-left-8"
                        onClick={debounce(onRefresh, 600)}
                    >
                        刷新
                    </Button>
                    <Button
                        className="margin-left-8"
                        onClick={onBack}
                    >
                        返回
                    </Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <RoForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
            <Divider orientation="left" />
            <RoDetailList getForm={getForm} />
            <PaymentDrawer getForm={getForm} />
            <RoPrint printRef={printRef} />
        </Card>
    );
}